export const PurpleRing = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11.5" cy="11.5" r="8.5" stroke="#8854F8" stroke-width="5.76975" />
    </svg>
  );
};
